import { useEffect, useState } from "react";
import { Copy, Trash2 } from "lucide-react";
import { toast } from "sonner";
import ImageUpload from "./ImageUpload";

export default function MediaLibrary({ api }) {
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/media").then((r) => setItems(r.data.items));
  useEffect(() => { load(); }, []);
  const copy = (u) => { navigator.clipboard?.writeText(u); toast.success("URL copied"); };
  const remove = async (id) => {
    if (!window.confirm("Remove from the library? Articles already using it keep working.")) return;
    await api.delete(`/admin/media/${id}`); load();
  };
  return (
    <div className="space-y-6 mt-8" data-testid="media-library">
      <div className="flex flex-wrap items-center gap-4">
        <div>
          <h2 className="font-head uppercase text-2xl text-[#1E1E1E]">Media library</h2>
          <p className="text-sm text-[#6E6E6E]">Upload photos from your computer (JPG, PNG, WEBP, GIF, HEIC · up to 15MB). Large images are resized for the web.</p>
        </div>
        <ImageUpload api={api} testid="media-upload" onUploaded={() => load()} />
      </div>
      {!items ? <p className="text-[#6E6E6E]">Loading…</p> : items.length === 0 ? <p className="text-[#6E6E6E]" data-testid="media-empty">No images yet.</p> : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {items.map((m) => (
            <div key={m.id} className="border-2 border-[#D3CFC0] bg-white group" data-testid={`media-item-${m.id}`}>
              <div className="aspect-[4/3] overflow-hidden bg-[#E7E3D9]"><img src={m.url} alt={m.alt || ""} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" /></div>
              <div className="p-2 text-xs space-y-1">
                <p className="truncate text-[#1E1E1E]" title={m.original_filename}>{m.original_filename || m.id}</p>
                <p className="text-[#6E6E6E]">{m.width}×{m.height}</p>
                <div className="flex gap-3">
                  <button data-testid={`media-copy-${m.id}`} onClick={() => copy(m.url)} className="flex items-center gap-1 underline whitespace-nowrap"><Copy size={12} /> Copy URL</button>
                  <button data-testid={`media-delete-${m.id}`} onClick={() => remove(m.id)} className="flex items-center gap-1 text-[#B3261E]"><Trash2 size={12} /> Remove</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
